import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, effect, EffectRef, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import * as QRCode from 'qrcode';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
    selector: 'app-qr-code',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './qr-code.component.html',
    styleUrls: ['./qr-code.component.scss']
})
export class QrCodeComponent implements AfterViewInit, OnDestroy {
    value = input<string>('');
    width = input<number>(250);
    showLabel = input<boolean>(false);
    @ViewChild('canvas') canvas?: ElementRef<HTMLCanvasElement>;
    private qrEffect?: EffectRef;

    constructor(private readonly toastService: ToastService) {
        this.qrEffect = effect(() => {
            // React to value/width changes; if canvas is not ready yet,
            // ngAfterViewInit will trigger the initial render.
            this.renderQRCode();
        });
    }

    ngAfterViewInit(): void {
        this.renderQRCode();
    }

    ngOnDestroy(): void {
        this.qrEffect?.destroy();
    }

    private renderQRCode(): void {
        const canvas = this.canvas?.nativeElement;
        const value = this.value()?.trim();
        const width = this.width();

        if (!canvas || !value) {
            return;
        }

        canvas.width = width;
        canvas.height = width;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${width}px`;

        void this.generateQRCode(canvas, value, width);
    }

    private async generateQRCode(canvas: HTMLCanvasElement, value: string, width: number): Promise<void> {
        try {
            await QRCode.toCanvas(canvas, value, {
                width,
                color: { dark: '#000000', light: '#FFFFFF' }
            });
        } catch (error) {
            this.toastService.showError('TOAST.ERROR', 'ERROR_FETCHING_QR_CODE', true);
            console.error('Error generating QR code:', error);
        }
    }
}
